import { render, staticRenderFns } from "./AgentPercentShare.vue?vue&type=template&id=a92ae048&scoped=true&"
import script from "./AgentPercentShare.vue?vue&type=script&lang=js&"
export * from "./AgentPercentShare.vue?vue&type=script&lang=js&"
import style0 from "./AgentPercentShare.vue?vue&type=style&index=0&id=a92ae048&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a92ae048",
  null
  
)

export default component.exports